/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopSourceRequest = {
    name: string;
    address?: string;
    identificationNumber?: string;
    phoneNumber?: string;
    line?: string;
    email?: string;
    vatType: ShopSourceRequest.vatType;
    note?: string;
    shopId: string;
};
export namespace ShopSourceRequest {
    export enum vatType {
        VAT = 'VAT',
        NON_VAT = 'NON_VAT',
    }
}

